export const environment = {
  production: false,
  name: "dev-remote",
  configUrl: "assets/config/dev-remote.json",
  integration:"&env=Sandbox"
};
